import React, {Fragment, useEffect } from 'react';
import { Link } from 'react-router-dom';

import { useAlert } from 'react-alert';

import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

import { useDispatch, useSelector } from 'react-redux';
import { getCategories, deleteCategoryData } from '../../../actions/adminCategoryActions';
//import { deleteUserData } from '../../../actions/commonActions';

import Loader from "../../Loader";
// import Loader from "react-loader-spinner";

const ListCategories = ({ history }) => {

    // const [users, setUsersData] = useState({});
    const alert = useAlert();
    const dispatch  = useDispatch();

    useEffect(() => {
        dispatch(getCategories());
    }, [dispatch]);

    const { categories, user_loading } = useSelector(state => state);

    const handleDeleteCategory = (id) => {
        confirmAlert({
            title: 'Confirm to submit',
            message: 'Are you sure to do this.',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => {
                        dispatch(deleteCategoryData(id));
                        alert.success('Category deleted successfully');
                        // history.push(`/admin/categories`);
                        dispatch(getCategories());
                    }
                },
                {
                    label: 'No',
                    onClick: () => alert.success('No data deleted')
                }
            ]
        });
    }

    return (
        <Fragment>
            {user_loading ? (
                <Loader />
            ) : (
                <Fragment>
                    <div className="content-wrapper">
                        <section className="content-header">
                            <h1>
                                Manage
                                <small>Categories</small>
                            </h1>
                            <ol className="breadcrumb">
                                <li><Link to="/admin"><i className="fa fa-dashboard"></i> Dashboard</Link></li>
                                <li className="active">Categories</li>
                            </ol>
                        </section>

                        <section className="content">
                            <div className="row">
                                <div className="col-xs-12">
                                    <div className="box">
                                        <div className="box-header">
                                            <h3 className="box-title">Categories</h3>
                                            <div className="box-tools">
                                                <Link to={"/admin/categories/add"} className="btn btn-success btn-sm">+ Add Category</Link>
                                            </div>
                                        </div>
                                        <div className="box-body table-responsive no-padding">
                                            <table className="table table-hover">
                                                <thead>
                                                <tr>
                                                    <th>Name</th>
                                                    <th>Slug</th>
                                                    <th>Description</th>
                                                    <th>Status</th>
                                                    <th>Action</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {categories.user_loading ? <Loader /> : ((categories.categories.length)? categories.categories.map(catItem => (
                                                    <tr key={catItem._id}>
                                                        <td>{catItem.title}</td>
                                                        <td>{catItem.seo_url}</td>
                                                        <td>{catItem.description}</td>
                                                        <td>
                                                            {catItem.status === 'Active' && (
                                                                <span className="badge bg-green">{catItem.status}</span>
                                                            )}
                                                            {catItem.status === 'InActive' && (
                                                                <span className="badge bg-yellow">{catItem.status}</span>
                                                            )}
                                                        </td>
                                                        <td>
                                                            <Link to={`/admin/categories/edit/${catItem._id}`} className="btn btn-success btn-sm" title="Edit" ><i className="fa fa-edit"></i></Link>
                                                            &nbsp;
                                                            <a className="btn btn-danger btn-sm"
                                                               title="Delete"
                                                               onClick={() => handleDeleteCategory(catItem._id)}
                                                               key={catItem._id}
                                                            ><i className="fa fa-trash"></i></a>
                                                        </td>
                                                    </tr>
                                                )): <tr>
                                                    <td colSpan="2">
                                                        No records found
                                                    </td>
                                                </tr>)}

                                                </tbody>
                                                <tfoot>
                                                </tfoot>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </section>
                    </div>
                </Fragment>
            )}
        </Fragment>
    )
}

export default ListCategories;
